import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { Card, CardBody } from '../../../components/card/card';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import Loading from '../../../components/Shared/Loader/Loading';
import NtxCustomModal from '../../../components/Modal/NtxCustomModal';
import HandOver from './HandOver';
import useGetEquipmentsList from '../../../hooks/FLeet/useGetEquipmentsList';
import { Form, Row, Col, Badge, Button } from 'react-bootstrap';
import Pagination from '@components/Shared/Pagination/Pagination';
import { useNavigate } from 'react-router-dom';

// const CardHandOver = () => {
//   const { HasPermission } = usePermissions();
//   const [show, setShow] = useState(false);
//   const [data, setData] = useState<any>({ id: null, equipmentsAssignationId: null, equipmentsAssignationDate: null });
//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [dataPerPage] = useState(8);

//   const { t, i18n } = useTranslation();

//   const { EquipmentsList, loading, error } = useGetEquipmentsList();

//   // Filter equipment - only show vehicles without drivers and apply search/filters
//   const filteredEquipments = EquipmentsList?.filter(
//     item =>
//       !item.peopleName &&
//       (item.plateNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.modelName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         item.modelName2?.toLowerCase().includes(searchTerm.toLowerCase())) &&
//       (statusFilter === 'all' || item.status === statusFilter)
//   );

//   const indexOfLastData = currentPage * dataPerPage;
//   const indexOfFirstData = indexOfLastData - dataPerPage;
//   const currentData = filteredEquipments?.slice(indexOfFirstData, indexOfLastData);

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//              link: ':moduleHome'
//             },
//             {
//               name: 'Handover',
//               link: null
//             }
//           ]}
//           PageName='Handover'
//         />
//       </div>

//       {/* Search and Filter Section */}
//       <Card className='mb-4'>
//         <CardBody>
//           <Row>
//             <Col md={8}>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fa fa-search text-theme me-2'></i>
//                   {t('Search')}
//                 </span>
//                 <input
//                   type='search'
//                   autoComplete='off'
//                   className='form-control'
//                   placeholder={t('Search')}
//                   value={searchTerm}
//                   onChange={e => setSearchTerm(e.target.value)}
//                 />
//               </div>
//             </Col>

//             <Col md={4}>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='bi bi-funnel'></i>
//                 </span>
//                 <Form.Select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
//                   <option value='all'>{t('All')}</option>
//                   <option value='Active'>{t('isActive')}</option>
//                   <option value='Inactive'>{t('InActive')}</option>
//                 </Form.Select>
//               </div>
//             </Col>
//           </Row>
//         </CardBody>
//       </Card>

//       {/* <Card>   */}
//       <Loading loading={loading} error={error}>
//         <Row>
//           {currentData?.map(item => (
//             <Col md={6} lg={4} xl={3} key={item.id} className='mb-4'>
//               <Card className='h-100 vehicle-card handover-card'>
//                 <div className='vehicle-image-container position-relative'>
//                   {item.image === null ? (
//                     <img alt={item.plateNo} className='vehicle-image' src='/assets/img/Image/carfleet.png' />
//                   ) : (
//                     <img alt={item.plateNo} className='vehicle-image' src={item?.image?.filePath} />
//                   )}
//                   <Badge bg={item.status === 'Active' ? 'success' : 'warning'} className='vehicle-status-badge'>
//                     <i
//                       className={`bi ${
//                         item.status === 'Active' ? 'bi-check-circle-fill' : 'bi-exclamation-triangle-fill'
//                       } me-1`}
//                     ></i>
//                     {item.status === 'Active' ? t('isActive') : t('InActive')}
//                   </Badge>
//                   <div className='availability-badge'>
//                     <Badge bg='secondary'>
//                       <i className='bi bi-clock-history me-1'></i>
//                       {t('Stand By')}
//                     </Badge>
//                   </div>
//                 </div>
//                 <CardBody className='d-flex flex-column'>
//                   <h6 className=''>
//                     <i className='bi bi-upc-scan me-2'></i>
//                     {item.plateNo}
//                   </h6>
//                   <p className=' text-muted mb-2'>
//                     <i className='bi bi-tag me-2'></i>
//                     {i18n.language === 'en' ? item.modelName : item.modelName2}
//                   </p>
//                   <div className='mt-auto'>
//                     <Button
//                       hidden={!HasPermission('FleetAddHandover')}
//                       variant='danger'
//                       className='w-100'
//                       onClick={() => {
//                         setData({
//                           id: item.id,
//                           equipmentsAssignationId: item.equipmentsAssignationId,
//                           equipmentsAssignationDate: item.equipmentsAssignationDate
//                         });
//                         setShow(true);
//                       }}
//                     >
//                       <i className='bi bi-arrow-left-circle me-1'></i>
//                       {t('Handover')}
//                     </Button>
//                   </div>
//                 </CardBody>
//               </Card>
//             </Col>
//           ))}

//           {filteredEquipments?.length === 0 && !loading && (
//             <Col className='text-center py-5'>
//               <i className='bi bi-car-front' style={{ fontSize: '3rem', color: '#6c757d' }}></i>
//               <p className='mt-3 text-muted'>{t('NoVehiclesAvailable')}</p>
//               <small className='text-muted'>{t('AllVehiclesHaveDrivers')}</small>
//             </Col>
//           )}
//         </Row>

//         <Pagination
//           filteredData={filteredEquipments}
//           dataPerPage={dataPerPage}
//           handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
//           currentPage={currentPage}
//         />
//       </Loading>
//       {/* </Card>  */}

//       <NtxCustomModal show={show} setShow={setShow} width='94%' title={t('Handover')}>
//         {data.id && <HandOver Id={data.id} onclose={() => setShow(false)} />}
//       </NtxCustomModal>

//       <style>
//         {`
//         .handover-card {
//           transition: transform 0.4s ease, box-shadow 0.2s ease;
//           border-top: 3px solid #dc3545;
//         }

//         .handover-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 4px 15px rgba(220, 53, 69, 0.1);
//         }

//         .vehicle-image-container {

//           position: relative;
//           height: 150px;
//           overflow: hidden;
//           background-color: transparent;
//           display: flex;
//           align-items: center;
//           justify-content: center;

//         }

//         .vehicle-image {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .vehicle-status-badge {
//           position: absolute;
//           top: 10px;
//           right: 10px;
//         }

//         .availability-badge {
//           position: absolute;
//           top: 10px;
//           left: 10px;
//         }

//         @media (max-width: 768px) {
//           .vehicle-image-container {
//             height: 150px;
//           }
//         }

//         .btn-danger {
//           background-color: #dc3545;
//           border-color: #dc3545;
//         }

//         .btn-danger:hover {
//           background-color: #bb2d3b;
//           border-color: #b02a37;
//         }
//         `}
//       </style>
//     </>
//   );
// };
const CardHandOver = () => {
  const { HasPermission } = usePermissions();
  const [show, setShow] = useState(false);
  const [data, setData] = useState<any>({ id: null, equipmentsAssignationId: null, equipmentsAssignationDate: null });
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(8);

  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const { EquipmentsList, loading, error } = useGetEquipmentsList();

  // Filter equipment - only show vehicles without drivers and apply search/filters
  const filteredEquipments = EquipmentsList?.filter(
    item =>
      !item.peopleName &&
      (item.plateNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.modelName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.modelName2?.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (statusFilter === 'all' || item.status === statusFilter)
  )?.filter(f=>f.status !== 'Inactive');

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredEquipments?.slice(indexOfFirstData, indexOfLastData);

  // console.log(currentData);

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Handover',
              link: null
            }
          ]}
          PageName='Handover'
        />
      </div>

      {/* Search and Filter Section */}
      <Card className='mb-4'>
        <CardBody>
          <Row>
            <Col md={8}>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fa fa-search text-theme me-2'></i>
                  {t('Search')}
                </span>
                <input
                  type='search'
                  autoComplete='off'
                  className='form-control'
                  placeholder={t('Search')}
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </Col>

            <Col md={4}>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='bi bi-funnel'></i>
                </span>
                <Form.Select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                  <option value='all'>{t('All')}</option>
                  <option value='Active'>{t('isActive')}</option>
                  <option value='Inactive'>{t('InActive')}</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Loading loading={loading} error={error}>
        <Row>
          {currentData?.map((item: any) => (
            <Col md={6} lg={4} xl={3} key={item.id} className='mb-4'>
              <Card className='h-100  handover-card'>
                <div className='vehicle-image-container position-relative'>
                  {item.image === null ? (
                    // عرض أيقونة المركبة مع خلفية شفافة حمراء
                    <div className='vehicle-icon-container'>
                      <i className='bi bi-car-front-fill vehicle-icon'></i>
                    </div>
                  ) : (
                    <img alt={item.plateNo} className='vehicle-image' src={item?.image?.filePath} />
                  )}

                  <Badge
                    bg={item.status === 'Active' ? 'success' : item.status === 'Inactive' ? 'warning' : 'secondary'}
                    className='vehicle-status-badge'
                  >
                    <i
                      className={`bi ${
                        item.status === 'Active'
                          ? 'bi-check-circle-fill'
                          : item.status === 'Inactive'
                          ? 'bi-exclamation-triangle-fill'
                          : 'bi-question-circle-fill'
                      } me-1`}
                    ></i>
                    {item.status === 'Active'
                      ? t('isActive')
                      : item.status === 'Inactive'
                      ? t('InActive')
                      : t('Unknown')}
                  </Badge>

                  <div className='availability-badge'>
                    <Badge bg='secondary'>
                      <i className='bi bi-clock-history me-1'></i>
                      {t('Stand By')}
                    </Badge>
                  </div>
                </div>
                <CardBody className='d-flex flex-column'>
                  <h6 className=''>
                    <i className='bi bi-upc-scan me-2'></i>
                    {item.plateNo}
                  </h6>
                  <p className=' text-muted mb-2'>
                    <i className='bi bi-tag me-2'></i>
                    {i18n.language === 'en' ? item.modelName : item.modelName2}
                  </p>
                  <div className='mt-auto'>
                    <Button
                      disabled={item.status !== 'Active'}
                      hidden={!HasPermission('FleetAddHandover')}
                      variant='danger'
                      className='w-100'
                      onClick={() => {
    
                        navigate(`${item.id}/HandOverForm`);
                      }}
                    >
                      <i className='bi bi-arrow-left-circle me-1'></i>
                      {t('Handover')}
                      
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}

          {filteredEquipments?.length === 0 && !loading && (
            <Col className='text-center py-5'>
              <i className='bi bi-car-front' style={{ fontSize: '3rem', color: '#6c757d' }}></i>
              <p className='mt-3 text-muted'>{t('NoVehiclesAvailable')}</p>
              <small className='text-muted'>{t('AllVehiclesHaveDrivers')}</small>
            </Col>
          )}
        </Row>

        <Pagination
          filteredData={filteredEquipments}
          dataPerPage={dataPerPage}
          handlePagination={(pageNumber: any) => setCurrentPage(pageNumber)}
          currentPage={currentPage}
        />
      </Loading>

      {/* <NtxCustomModal show={show} setShow={setShow} width='94%' title={t('Handover')}>
        {data.id && <HandOver Id={data.id} onclose={() => setShow(false)} />}
      </NtxCustomModal> */}

      <style>
        {`

         
        .handover-card {
          transition: transform 0.4s ease, box-shadow 0.2s ease;
          border-top: 3px solid #dc3545;
          border-color :  #dc3545;
        }

        .handover-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 15px rgba(220, 53, 69, 0.1);
        }

        .vehicle-image-container {
          position: relative;
          height: 150px;
          overflow: hidden;
          background-color: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
        }
          
        .vehicle-icon-container {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          background-color: rgba(220, 53, 69, 0.15); /* خلفية شفافة حمراء */
        }

        .vehicle-icon {
          font-size: 4rem;
          color: #dc3545; /* لون أحمر يتناسب مع التصميم */
        }

        .vehicle-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .vehicle-status-badge {
          position: absolute;
          top: 10px;
          right: 10px;
        }

        .availability-badge {
          position: absolute;
          top: 10px;
          left: 10px;
        }

        @media (max-width: 768px) {
          .vehicle-image-container {
            height: 150px;
          }
          
          .vehicle-icon {
            font-size: 3rem;
          }
        }

        .btn-danger {
          background-color: #dc3545;
          border-color: #dc3545;
        }
        
        .btn-danger:hover {
          background-color: #bb2d3b;
          border-color: #b02a37;
        }
        `}
      </style>
    </>
  );
};
export default CardHandOver;
